module.exports = __webpack_public_path__ + "img/Help-icon.e0aeac0a.svg";